export { NavigationMenuSubMenuItem } from './NavigationMenuSubMenuItem';

export { type NavigationMenuSubMenuItemProps } from '../types';
